<template>
  <div>
    <h2-hero @limitReached="showModal = true"/>
    <how-it-works-section />
    <value-props />
    <services-offered />
    <trending-services/>
    <our-customers-say />
    <faq-section />
    <become-a-pro />
    <services-modal />
    <customer-pro-modal />
    <limit-modal :showModal="showModal" @close="showModal = false"/>
  </div>
</template>

<script>
import { prefetchMixin } from '@/prefetch';
import H2Hero from './components/H2Hero';
import ServicesModal from './components/ServicesModal';
import BecomeAPro from './components/BecomeAPro';
import ValueProps from './components/ValueProps';
import HowItWorksSection from './components/HowItWorks';
import OurCustomersSay from './components/OurCustomersSay';
import FAQSection from './components/FAQSection';
import CustomerProModal from '../CustomerProModal';
import TrendingServices from './components/TrendingServices';
import ServicesOffered from './components/ServicesOffered';
import LimitModal from './components/LimitModal';

export default {
  name: 'app',
  components: {
    ServicesModal,
    H2Hero,
    BecomeAPro,
    ValueProps,
    HowItWorksSection,
    OurCustomersSay,
    'faq-section': FAQSection,
    CustomerProModal,
    TrendingServices,
    ServicesOffered,
    LimitModal,
  },
  mixins: [
    prefetchMixin,
  ],
  prefetch ({ store }) {
    return Promise.all([
      store.commit('homepage/geo/resetLocations'),
      store.dispatch('homepage/request/reset'),
      store.dispatch('homepage/search/reset'),
      store.dispatch('homepage/hierarchies/fetchHierarchies'),
      store.dispatch('homepage/trending/fetchNationalTrendingServices'),
      store.dispatch('homepage/contentful/fetchCustomerHomePage'),
      store.commit('homepage/setIsProHomepage', false),
    ]);
  },
  data () {
    return {
      showModal: false,
      stickyTriggerPoint: 465,
    };
  },
  methods: {
    openModal () {
      this.showModal = true;
      this.$events.$emit(this.$events.LIMIT_MODAL_OPEN);
    },
  },
};
</script>
